import { z } from "zod";

export type GatedAsset = {
  slug: string;
  title: string;
  file: string;
};

export const GATED_ASSETS: Record<string, GatedAsset> = {
  "pipo-migration-checklist": {
    slug: "pipo-migration-checklist",
    title: "SAP PI/PO to Integration Suite migration checklist (DOCX)",
    file: "/downloads/sap-pipo-integration-suite-migration-checklist.docx",
  },
  "pipo-vs-is-comparison": {
    slug: "pipo-vs-is-comparison",
    title: "SAP PI/PO vs. SAP Integration Suite comparison one-pager (PDF, English)",
    file: "/downloads/sap-pipo-vs-integration-suite-comparison-en.pdf",
  },
  "pipo-vs-is-comparison-de": {
    slug: "pipo-vs-is-comparison-de",
    title: "SAP PI/PO vs. SAP Integration Suite Vergleichs-One-Pager (PDF, Deutsch)",
    file: "/downloads/sap-pipo-vs-integration-suite-comparison-de.pdf",
  },
  "case-erp-conversion-readiness": {
    slug: "case-erp-conversion-readiness",
    title: "Case study: modern ERP conversion readiness (PDF)",
    file: "/downloads/case-studies/sap-technology-consulting-case-study-erp-conversion-readiness.pdf",
  },
  "case-integration-simplification": {
    slug: "case-integration-simplification",
    title: "Case study: integration landscape simplification (PDF)",
    file: "/downloads/case-studies/sap-technology-consulting-case-study-integration-simplification.pdf",
  },
  "case-database-performance": {
    slug: "case-database-performance",
    title: "Case study: database platforms performance stabilisation (PDF)",
    file: "/downloads/case-studies/sap-technology-consulting-case-study-database-performance.pdf",
  },
  "case-erp-conversion-readiness-tr": {
    slug: "case-erp-conversion-readiness-tr",
    title: "Vaka çalışması: modern ERP dönüşümü için hazırlık (PDF, Türkçe)",
    file: "/downloads/case-studies/sap-technology-consulting-case-study-erp-conversion-readiness-tr.pdf",
  },
  "case-integration-simplification-tr": {
    slug: "case-integration-simplification-tr",
    title: "Vaka çalışması: entegrasyon ortamının sadeleştirilmesi (PDF, Türkçe)",
    file: "/downloads/case-studies/sap-technology-consulting-case-study-integration-simplification-tr.pdf",
  },
  "case-database-performance-tr": {
    slug: "case-database-performance-tr",
    title: "Vaka çalışması: veritabanı platformlarında performans istikrarı (PDF, Türkçe)",
    file: "/downloads/case-studies/sap-technology-consulting-case-study-database-performance-tr.pdf",
  },
};

export const downloadRequestSchema = z.object({
  email: z.string().trim().email().max(200),
  slug: z.string().refine((value) => value in GATED_ASSETS, "Unknown download"),
  sourcePath: z.string().max(300).optional(),
  consent: z.literal(true, { message: "Please accept the privacy notice." }),
  consentText: z.string().max(1000).optional(),
  resend: z.boolean().optional(),
  // Honeypot — must stay empty.
  company: z.string().max(200).optional(),
  // Timing check: epoch ms when the form was rendered.
  startedAt: z.number().optional(),
});

export const DOWNLOAD_CONSENT_TEXT =
  "I agree that OXORY AS.DS GmbH may store my email address and send me the requested document. My data is processed only for this purpose and any related follow-up, is never sold, and I can withdraw my consent at any time by emailing info@oxory.net. Details: https://oxory.net/privacy";

export type DownloadRequestInput = z.infer<typeof downloadRequestSchema>;

export type DownloadRequestResult =
  | { ok: true; file: string; emailed: boolean }
  | { ok: false; message: string };
